// extracted by mini-css-extract-plugin
module.exports = {"stopOperation":"Overview_stopOperation__3GHTh","monthSelect":"Overview_monthSelect__3d6Sg","selectGroup":"Overview_selectGroup__whHh4"};